import react, {useState, useEffect, useRef} from "react";
import { Image as AntdImage, Tooltip, Pagination, Typography, Popconfirm, Spin, message } from "antd";
import { CloseCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { useDispatch } from "react-redux";
import * as marked from "marked";

import Api from '../../api'
import Iconfont from "../../components/Iconfont/Iconfont";
import storage from "../../utils/storage";
import QASearchInput from "../../components/qASearchInput/index.js";
import newTopic from "../../assets/img/V7/newTopic.svg";
import aiIcon from "../../assets/img/V7/aiIcon.svg";
import aiText from "../../assets/img/V7/aiText.svg";
import { goKnowledgeDetails , getSearchParams } from '../../utils/tool'
import { processingDataFormat, getQASourceIcon } from '../../utils/aiTool'
import { setAIModalState } from "../../features/AIIntelligent/AIReducer";
import down from "../../assets/img/V7/down.svg";
import upIcon from "../../assets/img/V7/upIcon.svg";

import "./index.scss";
const { Text, Link } = Typography;
let eventSource = null;
const KnowledgeQA = () => { 
    const dispatch = useDispatch();

    const contentRef = useRef(null);
    const userInfo = storage.getItem("userInfo") || {};
    const [questionType, setQuestionType] = useState([
        {lable:"全部", id:"0"},
        {lable:"基础知识", id:"1"},
        {lable:"参考资料", id:"2"},
        {lable:"经典案例", id:"3"}
    ]);
    const [questionTypeId, setQuestionTypeId] = useState('0');

    const [questionParam,setQuestionParam] = useState(null)
    const [answerDataList, setAnswerDataList] = useState([
        // {   
        //     "id":"1",
        //     "msgView":"1",
        //     "think":"这是深度思考的内容这是深度思考的内容这是深度思考的内容这是深度思考的内容这是深度思考的内容这是深度思考的内容",
        //     relQuestions:["推荐问题1","推荐问题2"]
        // }
    ]);
    let defaultAnswerDataList = [];
    
    const [isAnswering, setIsAnswering] = useState(false);
    const [clientId, setClientId] = useState(null);
    const [questionId, setQuestionId] = useState(null);
    const [historyPage, setHistoryPage] = useState({
        pageSize: 10,
        pageIndex: 1,
    });
    const [historyTotal, setHistoryTotal] = useState(0);
    const [lmQaLogId, setLmQaLogId] = useState(null);
    const [recommendValue, setRecommendValue] = useState("");

    
    // 提示框
    const [aIModalTips,setAIModalTips] = useState({})

    const [searchParam, setSearchParam] = useState({
        lmQaLogId:null,
        pageIndex: 1,
        pageSize:10
    });
    const [moreLoading, setMoreLoading] = useState(false);
    const [noMore, setNoMore] = useState(true);

    useEffect(()=>{ 
        let aiQAParams = storage.getItem("aiQAParams");
        if(getSearchParams().lmQaLogId){
            setLmQaLogId(getSearchParams().lmQaLogId)
            setSearchParam({
                "lmQaLogId": getSearchParams().lmQaLogId,
                "pageIndex": 1,
                "pageSize": 10,
            });
        }else if(aiQAParams){
            console.log(aiQAParams,"_aiQAParams")
            assembleSendParameters(aiQAParams);
        }

        // 设置最小高度，在AI回答数据不多的时候让输入框保持在最底部
        let minHeight = document.querySelector('.knowledgeQA').clientHeight - 200;
        document.querySelector('#QAListBox').style.minHeight  = minHeight+"px";
        console.log(document.querySelector('.knowledgeQA').clientHeight - 185,"_getSearchParams")
        
    },[])


    useEffect(()=>{
        if(searchParam.lmQaLogId){
            getQAHistory(searchParam.pageIndex > 1 ? '' : 'history');
        }
    },[searchParam])


    // 结束当前话题的提示框
    useEffect(()=>{
        if(aIModalTips && aIModalTips.timeOut != 'maintain'){
            setTimeout(()=>{
                setAIModalTips(false);
            },2000)
        }
    },[aIModalTips])


    useEffect(() => {
        const handleClick = (event, dataList, lmQaLogId) => {
            // 确保点击事件来自于设置的HTML内容
            if (contentRef.current && event.target.closest('.onClickGoDetails')) {
                console.log(event.target,"target")
                console.log(event.target.dataset,"dataset")
                let sourceType = event.target.classList[0]
                let id = event.target.dataset.myData;
                let myIndex = event.target.dataset.myIndex;

                if(sourceType === "webSources"){ 
                    dataList.map(item=>{ 
                        if(item.id === id){ 
                            window.open(item[sourceType][myIndex].url)
                        }
                    })
                }

                if(sourceType === "knowledgeSources"){
                    dataList.map(item=>{ 
                        if(item.id === id){ 
                            let sourceItem = item.sources[myIndex];

                            // 去除重复数据
                            const newSource = item.sources.filter((items, index, self) =>
                                index === self.findIndex(i => {
                                    if(items.knowledgeId){
                                        return i.knowledgeId === items.knowledgeId
                                    }else if(items.policyId){
                                        return i.policyId !== items.policyId
                                    }
                                })
                            );

                            dispatch(setAIModalState({
                                multiKnowledgeList: newSource,
                                multiOpen: true,
                                multiKnowledgeIds:[sourceItem.knowledgeId || sourceItem.policyId],
                                query:"",
                                sendAPI:false,
                                multiPage:sourceItem.pages[0],
                                multiChatId: lmQaLogId
                            }))

                            // if(sourceItem.knowledgeTypeId){
                            //     goKnowledgeDetails({
                            //         ...item,
                            //         type: sourceItem.knowledgeTypeId === '4' ? sourceItem.policyId : sourceItem.knowledgeId,
                            //         pages: sourceItem.pages
                            //     })
                            // }else{
                            //     window.open('newKnowledge?knowledgeId='+sourceItem.knowledgeId+'&type=view');
                            // }
                        }
                    })
                }

                // console.log(event.target.dataset.myData,"myData")
                // let _largeModelQaLogDeatilId = event.target.dataset.myData
                // num = num.replace('[', '').replace(']', '');
                // if(aiType === 'detailsSum' && callbackPositioning){
                //     // 单文档 - 知识详情中问答 -- 点击直接当前页定位
                //     callbackPositioning(parseInt(num) - 1, _largeModelQaLogDeatilId)
                // }else{
                //     console.log(parseInt(num) - 1,largeModelQaLogDeatilId,"numnumnum")
                //     getSource(parseInt(num) - 1,_largeModelQaLogDeatilId)
                // }
            }
        };

        
        if(!isAnswering){
            // 添加点击事件监听器到document
            document.addEventListener('click', (event)=>{
                handleClick(event, answerDataList, lmQaLogId)
            });
        }else{
            document.removeEventListener('click', (event)=>{
                handleClick(event, answerDataList, lmQaLogId)
            });
        }
        
        // 清理函数，组件卸载时移除事件监听
        return () => {
            document.removeEventListener('click', (event)=>{
                handleClick(event, answerDataList, lmQaLogId)
            });
        };
    }, [isAnswering, JSON.stringify(answerDataList)]);


    useEffect(()=>{
        console.log("useEffect",noMore)
        if(!noMore){
            const dom = document.getElementById("knowledgeQA"); 
            if (dom) {
                addEventListenerF();
            }
        }else{
            removeEventListenerF();
        }
    },[noMore])
    
    
    const addEventListenerF = () => {
        if(document.getElementById('knowledgeQA')){
            document.getElementById('knowledgeQA').addEventListener("scroll",useFn);
        }
    }

    const removeEventListenerF = () => {
        if(document.getElementById('knowledgeQA')){
            document.getElementById('knowledgeQA').removeEventListener("scroll", useFn);
        }
    }


    /**
     * 判断是否触底
     * 此函数进行判断是否触底
     * @param    handler  必填  判断后执行的回调函数
     * @returns  null
     */
    const isTouchBottom = (handler, noMore) => {

        let scrollTop = Math.ceil(document.querySelector('#knowledgeQA').scrollTop);
        
        if(scrollTop === 0){
            handler();
        }
    };
    const handleLoadMore = () => {

        removeEventListenerF();

        setMoreLoading(true);
        
        setSearchParam({
            ...searchParam,
            "pageIndex":searchParam.pageIndex+1,
        });
    };
    const useFn = () => {
        // 此处调用 加载更多函数
        isTouchBottom(handleLoadMore, noMore);
    };

    const assembleSendParameters = async(param) => {
        setRecommendValue("");
        if (isAnswering) {
            setAIModalTips({
                status: "error",
                msg: "请先等待上次问题回答完成！",
            })
            return false;
        }

        /**
         * 知识id
         */
        // private List<Long> knowledgeIds;

        /**
         * 政策id
         */
        // private List<Long> policyIds;

        /**
         * 文件id
         */
        // private List<Long> fileIds;

        let fileInforList = [],
            errorList = [],
            imgFileInforList = [],
            imageIds=[],
            fileIds=[];

        if (param.fileList && param.fileList.length > 0) {
            param.fileList.map((item) => {
                if (["jpeg", "jpg", "png", "tiff", "tif", "bmp"].includes(
                    item.type
                )) {
                    imageIds.push(item.otherData.fileId);
                    imgFileInforList.push({
                        ...item,
                    });
                } else {
                    fileIds.push(item.otherData.fileId);
                    fileInforList.push({
                        ...item,
                    });
                }

            });
        }
        
        let knowledgeIds = [], policyIds = [];
        if(param.knowledgeList && param.knowledgeList.length > 0){
            param.knowledgeList.map(items => {
                let id = items.id || items.knowledgeId || items.policyId || items.elasticId;
                if(items.knowledgeTypeId === '4'){
                    policyIds.push(id);
                }else{
                    knowledgeIds.push(id);
                }
            });
        }


        if (param.query.replace(/\s/g, "").length > 0) {
            setIsAnswering(true)
            let newDataList = [...answerDataList];
            let id = Date.now().toString();

            newDataList.push({
                id,
                userId: userInfo.userId,
                messageData: {
                    query: param.query,
                    text: param.text,
                },
                // sysFiles: fileInforList,
                // imgFiles: imgFileInforList,
                logType: 0, //0发送消息 1接收消息
            });

            newDataList.push({
                logType: "ansewrLoading",
                id: Date.now().toString() + "1",
            });
            setAnswerDataList(newDataList);

            let _param = {};

            if(questionParam){
                // 有参数，继续提问的情况
                console.log('questionParam', questionParam);
                _param = {
                    query: param.query,
                    knowledgeIds: [...questionParam.ext.knowledgeIds],
                    policyIds: questionParam.ext.policyIds,
                    imgIds: [...questionParam.ext.imgIds],
                    fileIds: [...questionParam.ext.fileIds],
                    lmQaLogId: lmQaLogId,
                    KnowledgeEsParam: param.KnowledgeEsParam,
                    selectKnowledgeParam: param.selectKnowledgeParam,
                    searchScope: param.searchScope,
                }
            }else{
                // 第一次提问，或者结束话题后提问
                _param = {
                    ...param,
                    fileIds: [...fileIds],
                    // useKb: fileIds && fileIds.length > 0 ? true : false,
                    imgIds: [...imageIds],
                    knowledgeIds: knowledgeIds,
                    policyIds: policyIds,
                }
            }
            
            setQuestionId(id);
            console.log(newDataList, _param,"newDataList");
            sendQuestion(null, _param, newDataList);
        }
    }

    const sendQuestion = (id, inputParam, newDataList) =>{
        let postData = {};
        if(inputParam && inputParam.query){
            postData = {
                param: {
                    chatType: "rag",
                    messageData: {
                        query: inputParam.query,
                        msgType: "ragChat", //消息子类型 sys/ragChat/summary/ragRetrieve
                        relQuestions: 3, //问题推荐数量
                        useKb: true,
                        modelKey: 'Qwen3-32B-v0.9.2'
                        // 默认传32B模型 后端根据长度确定模型
                        // (
                        //     (inputParam.fileIds && inputParam.fileIds.length > 0 ) ||
                        //     (inputParam.policyIds && inputParam.policyIds.length > 0 ) 
                        // ) ? 'Qwen2.5-7B-Instruct-1M' : 'Qwen3-32B-v0.9.2'
                    },
                },
                ext: {
                    knowledgeIds: [...inputParam.knowledgeIds],
                    policyIds: inputParam.policyIds,
                    imgIds: [...inputParam.imgIds],
                    fileIds: [...inputParam.fileIds],
                    lmQaLogId: lmQaLogId,
                    KnowledgeEsParam: inputParam.KnowledgeEsParam,
                    selectKnowledgeParam: inputParam.selectKnowledgeParam,
                    searchScope: inputParam.searchScope,
                },
            };
        }

        setQuestionParam(postData);
        
        // ai问答范围
        // 首页
        // ES搜索
        // 知识中心
        // 个人资料
        // 专题收藏
        // 单文件详情问答



        // let data = {
        //     query: sendQuestionText || queryText,
        //     module: questionModule,
        //     largeModelQaLogId: chatId,
        //     questionLocation,
        //     knowledgeIds,
        //     refLoc,
        //     relQuestions,
        //     knowledgeEsParam,
        //     selectKnowledgeParam,
        //     knowledgePublishedParam,
        //     ...param,
        // };

        eventSource = fetchEventSource("/api/lm/chat/createConnect",
        {
            openWhenHidden: true,
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Accept: "text/event-stream",
                satoken: storage.getItem("token"),
            },
            onopen(event) {
                console.info("createConnect链接创建成功：", event);
                chatAreaScrollBottom();
            },
            onmessage(event) {
                // console.info("createConnect接受到回复：",event.data);
                chatAreaScrollBottom();
                if (event.data) {
                    receiveMessage(event, postData, id, newDataList ? newDataList : answerDataList);
                }
            },
            onclose(ee) {
                // 关闭流
                console.log("createConnect关闭");
                
            },
            onerror(error) {
                console.info("createConnectError",error);
                throw error;
            },
        })
    }

    const receiveMessage = (event, postData, reAnswerId, newDataList) => {
        try {
            const data = event.data;
            let decodeData = null,
            messageInfo = null;
            if (data) {
                decodeData = JSON.parse(data);
            } else {
                setIsAnswering(false);
                console.error("数据格式错误1:", data);
                return false;
            }

            if (decodeData.clientId) {
                setClientId(decodeData.clientId);
                if (reAnswerId) {
                    // 重新问答
                    historyPage.pageIndex = 1;
                    getQAHistory("reAnswers");

                    sendReAnswers({
                        clientId: decodeData.clientId,
                        id: reAnswerId,
                    })
                } else {
                    postData.ext.clientId = decodeData.clientId;
                    sendQuestionParam(postData)
                }
            } else if (decodeData.data) {
                messageInfo = decodeData.data;
            } else {
                setIsAnswering(false);
                console.error("数据格式错误2:", decodeData.data);
                return false;
            }


            if (messageInfo && messageInfo.data) {
                let _data = messageInfo.data;
                setLmQaLogId(_data.lmQaLogId);
                _data.logType =  "ansewrLoading"
                if (_data.isEnd) {
                    _data.logType =  ""
                    console.log(messageInfo.data, "messageInfo");
                    console.log(answerDataList, "结束");
                    setIsAnswering(false);
                    // 获取当前聊天id
                    // setChatId(_data.largeModelQaLogId);
                    // setLargeModelQaLogDeatilId(_data.largeModelQaLogDeatilId);
                    // 关闭连接
                    closeConnection();
                }

                let formatContent = marked.parse(_data.answer || "");
                _data.answer = formatContent;
                _data.answerText = formatContent.replace(/<[^>]*>/g, "");
                
                _data.code = _data.code;
                _data.think = _data.think;
                // _data.sourcesTotal = 
                // (_data.sources ? _data.sources.length : 0) +
                // (_data.publicSources ? _data.publicSources.length : 0)+
                // (_data.exSources ? _data.exSources.length : 0)+
                // (_data.webSources ? _data.webSources.length : 0)
                _data.sourcesTotal = _data.sources ? _data.sources.length : 0;

                if (_data.think) {
                    if (_data.answer) {
                        _data.thinkOpen = false;
                    } else {
                        _data.thinkOpen = true;
                    }
                } else {
                    _data.thinkOpen = false;
                }

                let _newDataList = newDataList ? [...newDataList ] : [...answerDataList];
                if (_data.isEnd) {
                    console.log("newDataList123", _newDataList);
                }

                _newDataList[_newDataList.length - 1] = _data;
                setAnswerDataList(_newDataList);

            }

            setTimeout(() => {
            chatAreaScrollBottom();
            }, 100);
        } catch (error) {
            console.log(error);
        }
    }
        // 关闭会话
    const closeConnection = async(type) => {
        console.log(eventSource, "调用关闭");

        if (clientId) {
            let res = await Api.ChatV7.closeConnect({data: {
                clientId: clientId,
            }})
            if (res.code === 0) {
                console.log(res, "关闭成功");
                // if(type === 'manualClick'){

                // }
                // setClientId(null);
            } else {
                console.log(res, "关闭失败");
                message.error("停止对话失败");
            }
        }
        
        if (eventSource && eventSource.close) {
            eventSource.close(); // 关闭连接
            eventSource = null;
        }

        
        if(type === 'manualClick'){
             let _newDataList = [...answerDataList];

            _newDataList.map((item) => {
                if (item.logType === "ansewrLoading") {
                    item.logType = "ansewrStop";
                    item.isEnd = true;
                }
            });

            setAnswerDataList(_newDataList);
        }

       

        setIsAnswering(false)
    }

    const sendQuestionParam = async(postData) => {
        try{
            let res = await Api.ChatV7.sendQAParam({data: postData})
            if(res&&res.code === 0){

            }
        }catch(e){ 
        }
    }   

    // 获取历史会话
    const getQAHistory = async(type, id) => {
        
        let response = await Api.ChatV7.pageQa({data: type === "reAnswers" ? {
                lmQaLogId: lmQaLogId,
                pageSize: historyPage.pageSize,
                pageIndex: historyPage.pageIndex,
            } : searchParam
        })
        
        if (response.code === 200 && response.rows.length > 0) {
            let historyData = [];

            if (type === "reAnswers") {
                historyData = [...response.rows.reverse()];
                historyData[historyData.length - 1].logType = "ansewrLoading";
                historyData[historyData.length - 1].answer = "";
                historyData[historyData.length - 1].relQuestions = [];
                historyData[historyData.length - 1].isEnd = false;
            } else if (type === "history") {
                historyData = [...response.rows.reverse()];
            } else {
                historyData = [...response.rows.reverse(), ...answerDataList];
            }

            historyData.map((item) => {
                let formatContent = marked.parse(item.answer || "");
                item.answer = formatContent;
                item.answerText = formatContent.replace(/<[^>]*>/g, "");
                item.sourcesTotal = item.sources ? item.sources.length : 0;
            });
            setAnswerDataList(historyData)
            setLmQaLogId(response.rows[0].lmQaLogId);
            setHistoryTotal(response.total);
            setMoreLoading(false);

            
            if (historyPage.pageIndex === 1 && searchParam.pageIndex === 1) {
                setTimeout(() => {
                    chatAreaScrollBottom();
                }, 600);
            }

            if (
                searchParam.pageIndex >= (response.total / searchParam.pageSize)
            ) {
                setNoMore(true);
                removeEventListenerF();
            } else {
                setNoMore(false);
            }
        } else {
            setAnswerDataList([])
        }
    }

    // 重新回答
    const reAnswers = (item) => {
        sendQuestion(item.parentId);
    }

    // 发送重新问答的参数
    const sendReAnswers = async(param) => { 
        try{
            const response = await Api.ChatV7.reAnswer({data:param})
            if (response.code === 0) {}
        }catch(e){}
    }


    // 聊天区域滚动到底部
    const chatAreaScrollBottom =() => {
        const dom = document.getElementById("knowledgeQA");
        if (dom) {
            dom.scrollTop = dom.scrollHeight - dom.clientHeight;
        }
    }
    
    const questionTypeChange = (value) => {
        setQuestionTypeId(value);
    }

   

    // 新建话题
    const endTopic = async() => { 
        setAIModalTips({
            status: "success",
            msg: "话题结束成功！",
        })
        setClientId(null);
        setLmQaLogId(null);
        setAnswerDataList([]);
        setQuestionParam(null);
        storage.removeItem("aiQAParams");

        if (clientId) {
            let res = await Api.ChatV7.closeConnect({data: {
                clientId: clientId,
            }})
            if (res.code === 0) {
                console.log(res, "关闭成功");
            } else {
                console.log(res, "关闭失败");
                message.error("停止对话失败");
            }
        }

        if (eventSource && eventSource.close) {
            eventSource.close(); // 关闭连接
            eventSource = null;
        }

        setIsAnswering(false);

        // try{
        //     const response = await Api.ChatV7.endQA(param)
        //     if (response.code === 0) {
        //         setAIModalTips({
        //             status: "success",
        //             msg: "话题结束成功！",
        //         })
        //         setAnswerDataList([])
        //     }
        // }catch(e){}
        
    }

    // 深度思考
    const handleChangeThink = (param) => {
        let newDataList = [...answerDataList];
        newDataList.map((item) => {
            if (item.id === param.id) {
                item.thinkOpen = !item.thinkOpen;
            }
        });
        setAnswerDataList(newDataList)
    }

    // 修改点赞状态
    const likeOrDisLike = async(param,type) => {
        let msgView = "";
        if (type === "dislike") {
            msgView = param.msgView === 1 ? 2 : 1;
        } else if (type === "like") {
            msgView = param.msgView === 0 ? 2 : 0;
        }
        try{
            const res = await Api.ChatV7.evaluate({
                data:{
                    id: param.id,
                    msgView: msgView, //0 点赞，1 点踩  2 取消
                }
            })
            if (res.code === 0) {
                let newDataList = [...answerDataList];
                newDataList.map((item) => {
                    if (item.id === param.id) {
                        item.msgView = msgView;
                    }
                });
                setAnswerDataList(newDataList);
            }
        }catch(e){}
    }

    // 复制
    const copyAnswers = (item) => {
        var textarea = document.createElement("textarea");
        textarea.style.position = "fixed";
        textarea.style.opacity = 0;
        textarea.value = item.answerText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        message.success("复制成功");
    }

    // 删除
    const deleteAnswers = async(data) => {
        try{
            const response = await Api.ChatV7.deleteALog({data:{lmQaLogDetailId: data.id}})
            // 传参删除
            if (response.code === 0) {
                if (data.totalPage > 1) {
                    paginationChange({
                        currentPage: data.totalPage - 1,
                        pageSize: 1,
                        param: data,
                    });
                } else {
                    let newDataList = [...answerDataList];
                    newDataList.map((item, index) => {
                        if (item.id == data.id) {
                            // item = {
                            //     answerText:"暂无回答",
                            //     logType: "delete",
                            // }
                            newDataList.splice(index, 1);
                        }
                    });
                    
                    setAnswerDataList(newDataList);
                }
                message.success(`删除成功`);
            }

        }catch(e){}
    }

    // 翻页
    const paginationChange = async({ currentPage, pageSize, param }) => {
        console.log(currentPage, pageSize);
        try{
            const res = await Api.ChatV7.pageAByParentId({
                data:{
                    pageIndex: currentPage,
                    pageSize: pageSize,
                    parentId: param.parentId,
                }
            })
            if (res.code === 200) {
                
                let newDataList = [...answerDataList];
                newDataList.map((item) => {
                    if (item.id === param.id) {
                        let formatContent = marked.parse(res.rows[0].answer || "");
                        item.answerText = formatContent.replace(/<[^>]*>/g, "");
                        item.answer = formatContent;
                        item.id = res.rows[0].id;
                        item.relQuestions = res.rows[0].relQuestions;
                        item.msgView = res.rows[0].msgView;
                        item.totalPage = res.rows[0].totalPage;
                        item.pageIndex = currentPage;
                    }
                });
                setAnswerDataList(newDataList);
            }
        }catch(e){}
    }

    // 点击推荐问题
    const onClickRecommend = (value) => {
        setRecommendValue(value);
    }

    const answerList = (item) => {
        if(!item){return false;}
        const {id, userId, query, answer, parentId, relQuestions, questionType, status: supportStatus, sources, messageType, largeModelQaLogId} = item;
        const messageContentId = `messageContent-${id}`;
        const tipstId = `tips-${id}`;
        // 去掉最后一个换行
        let formatContent = answer.replace(/[\n|\r]$/, "");
        // 处理数据格式
        let detailsID = id;

        if(sources && sources.length > 0){
            formatContent = processingDataFormat(formatContent, detailsID, 'onClickGoDetails', sources);
        }
        
        return (
            <div className="messageContentBox" key={id}>
                <div
                    ref={contentRef}
                    className={`messageContent answerMessageContent`}
                    id={messageContentId}
                    dangerouslySetInnerHTML={{__html: formatContent}}
                ></div>
            </div>
        )
    }

     // 关联文件的展开和收起
    const expandFileDes = (itemData, sourceItem,sourceType, sourceIndex) => {
        let _answerDataList = [...answerDataList];
        console.log(_answerDataList,"_answerDataList")
        _answerDataList.map(item=>{ 
            if(item.id === itemData.id){ 
                item[sourceType][sourceIndex].expand = item[sourceType][sourceIndex].expand ? !item[sourceType][sourceIndex].expand : true;
            }
        })
        
        setAnswerDataList([..._answerDataList])
        // let _sourceFileList = [...sourceFileList];
        // _sourceFileList.map(item => { 
        //     if(item.id === value.id){
        //         item.expand = !item.expand;
        //     }
        // })
        // setSourceFileList(_sourceFileList);
    }

    const upDownAll = (itemData, sourceType, type) => {
        let _answerDataList = [...answerDataList]
        _answerDataList.map(item=>{ 
            if(item.id === itemData.id){ 
                item[sourceType].map(items=>{
                    items.expand = type;
                })
            }
        })
        
        setAnswerDataList([..._answerDataList])
    }

    const viewFullText = (sourceItem,sourceType) => {

        {/* knowledgeTypeId 为空就是没发布，政策4 研报7 */}

        {/* A:知识库文档 - sources
        B:公共知识库文档 - publicSources
        C:外部知识库文档 - exSources
        D:联网搜索文档 - webSources
        E:图片来源 */}

        if(sourceItem.knowledgeTypeId){
            goKnowledgeDetails({
                ...sourceItem,
                type: sourceItem.knowledgeTypeId === '4' ? sourceItem.policyId : sourceItem.knowledgeId,
                pages: sourceItem.pages
            })
        }else{
            window.open('newKnowledge?knowledgeId='+sourceItem.knowledgeId+'&type=view');
        }
        // if(sourceType === "webSources"){
        //     window.open(sourceItem.url);
        // }
    }

    const stopAnswer = () => {
        closeConnection('manualClick');
    }

    const getSourcesHTml = (itemData, sources, sourceType) => {   
        return (
            <div className="sourceListBox">
                {sources.map((item, index) => { 
                    let formatContent = marked.parse(item.content || "");
                    let newContent = formatContent;
                    return item.expand ? <div className="fileItemDes" key={index} onClick={()=>{expandFileDes(itemData, item,sourceType, index)}}>
                        
                        {/* {sourceType === "webSources" && <AntdImage
                            src={linkIcon}
                            preview={false}
                        />} */}
                        {/* knowledgeTypeId 为空就是没发布，政策4 研报7 */}
                        <div className="fileItemContent">
                            <div className="title">{item.title}</div>
                            <div className="content" dangerouslySetInnerHTML={{__html: newContent}}></div>
                            <Link target="_blank" onClick={(e) => { 
                                e.stopPropagation();
                                e.preventDefault();
                                viewFullText(item, sourceType);
                            }}>查看全文</Link>
                        </div>
                    </div>: <div className="fileListItem" key={index} onClick={()=>{expandFileDes(itemData, item,sourceType, index)}}>
                        {/* {sourceType === "webSources" && <AntdImage
                            src={linkIcon}
                            preview={false}
                        />} */}
                        {/* <UploadFileIcon fileType={item.fileType}/> */}
                        {getQASourceIcon(item.fileType)}
                        <div>{item.title}</div>
                    </div>
                })}
            </div>
        )
    }

    return <div className="knowledgeQA" id="knowledgeQA">
        <div className="QAListBox"  id="QAListBox">
            <div className="QABox">
                
                {/* <div className="typeBox">
                    {questionType.map(item=>{
                        return <div onClick={()=>questionTypeChange(item.id)} className={`typeItem ${questionTypeId === item.id ? 'active':''}`}>{item.lable}</div>
                    })}
                </div> */}
                {moreLoading&&<Spin tip={"加载中..."} size={"small"} style={{width: "100%"}}></Spin>}

                {answerDataList && answerDataList.length > 0 ? answerDataList.map((item,index)=>{
                    return<div 
                    key={index} 
                    style={item.logType === 0 ? {marginTop: '1rem', marginRight:'27rem'} : {marginBottom: '3rem'}}>
                        {item.logType === 0 ? <div className="questionBox">{item.messageData.query}</div> : 
                        <div className="answerBox">
                            <div className="answerLeft">
                                {item.think&&<>
                                    <span className="deepThinkingBtn" onClick={()=>handleChangeThink(item)}>
                                        已深度思考
                                        <Iconfont type={item.thinkOpen ? "icon-xiala" : "icon-shangjiantou4"} />
                                    </span>
                                </>}

                                {item.think&&item.thinkOpen&&<div className="deepThinkingContent">{item.think}</div>}

                                {item.answer && answerList(item)}

                                <div>
                                    {item.logType === "ansewrLoading" && <Spin size={"small"} style={{marginLeft: 10}}></Spin>}
                                </div>


                                {(item.isEnd || item.logType === 'ansewrStop') && <div className="operateBtnBox">
                                    <div>
                                        {/* 复制 */}
                                        {item.answerText && <span
                                            className={`operateBtn`}
                                            onClick={() => copyAnswers(item)}
                                        ><Iconfont type="icon-fuzhi1"/></span>}
                                        
                                        {/* 删除 */}
                                        {(item.id && (item.think || item.answer)) && <Popconfirm
                                            title="确定删除这条回答信息吗?"
                                            onConfirm={()=>deleteAnswers(item)}
                                            okText="确定"
                                            cancelText="取消"
                                        >
                                            <span
                                                className={`operateBtn`}
                                            ><Iconfont type="icon-delete"/></span>
                                        </Popconfirm>}

                                        {item.parentId && <span
                                            className={`operateBtn`}
                                            onClick={()=>reAnswers(item)}
                                        >
                                            <Iconfont type="icon-tongbu"/>
                                            <span className="operateBtnText">重新回答</span>
                                        </span>}
                                        
                                        {(item.id && (item.think || item.answer)) && <Tooltip 
                                            placement={"top"} 
                                            title={"答得不错"}
                                        >
                                            <span
                                                className={`operateBtn ${item.msgView === 0 ? "lightStatus" : ""}`}
                                                onClick={() => {
                                                    likeOrDisLike(item,'like');
                                                }}
                                            ><Iconfont type="icon-dianzan"/></span>
                                        </Tooltip>}
                                        {(item.id && (item.think || item.answer)) && <Tooltip placement={"top"} title={"还不够好"}
                                        >
                                            <span
                                                className={`operateBtn ${item.msgView === 1 ? "lightStatus" : ""}`}
                                                onClick={() => {
                                                    likeOrDisLike(item,'dislike');
                                                }}
                                            ><Iconfont type="icon-diancai"/></span>
                                        </Tooltip>}
                                    </div>

                                    {item.totalPage && item.totalPage > 1 && <Pagination 
                                        simple 
                                        current={item.pageIndex ? item.pageIndex: item.totalPage} 
                                        total={Number(item.totalPage)}  
                                        pageSize={1}
                                        onChange={(page, pageSize)=>paginationChange({
                                            currentPage: page,
                                            pageSize: pageSize,
                                            param: item,
                                        })}
                                    />}
                                </div>}

                                <div className="recommendList">
                                    {item.relQuestions && item.relQuestions.length > 0 && item.relQuestions.map((item,index)=>{
                                        return <Link target="_blank" key={index} onClick={()=>onClickRecommend(item)}>{item}</Link>
                                    })}
                                </div>
                                
                            </div>
                            <div className="answerRight">

                                <div className="typeBox">
                                    <div className={`typeItem active`}>来源</div>
                                    <Text type="secondary" className="fileNum">{item.sourcesTotal}个文件</Text>
                                    {((item.isEnd || item.logType === 'ansewrStop') && item.sourcesTotal > 0) && <div className="oprationBox">
                                        <Tooltip title="全部收起">
                                            <img src={upIcon} onClick={()=>upDownAll(item,"sources", false)} />
                                        </Tooltip>
                                        <Tooltip title="全部展开">
                                            <img src={down} onClick={()=>upDownAll(item,"sources" , true)} />
                                        </Tooltip>
                                    </div>}
                                </div>
                                {(item.isEnd || item.logType === 'ansewrStop') && <div className="fileList">
                                    {/* A:知识库文档 - sources
                                    B:公共知识库文档 - publicSources
                                    C:外部知识库文档 - exSources
                                    D:联网搜索文档 - webSources
                                    E:图片来源 */}
                                    {/* A:知识库文档 - sources */}
                                    {item.sources && item.sources.length>0 && getSourcesHTml(item, item.sources,"sources")}
                                    {/* B:公共知识库文档 - publicSources */}
                                    {/* {item.publicSources && item.publicSources.length>0 && getSourcesHTml(item, item.publicSources,"publicSources")} */}
                                    {/* C:外部知识库文档 - exSources */}
                                    {/* {item.exSources && item.exSources.length>0 && getSourcesHTml(item, item.exSources,"exSources")} */}
                                    {/* D:联网搜索文档 - webSources */}
                                    {/* {item.webSources && item.webSources.length>0 && getSourcesHTml(item, item.webSources,"webSources")} */}
                                    
                                </div>}
                            </div>
                        </div>}
                    </div>
                }):<div className="knowledgeContentAITitle">
                    <div className="knowledgeContentAIImg">
                        <AntdImage
                            preview={false}
                            src={aiIcon}
                        />
                        <AntdImage
                            preview={false}
                            src={aiText}
                        />
                    </div>
                    <div className="knowledgeContentAIText">查资料、读文件、解疑惑、做分析一起来挖掘更多实用功能吧！</div>
                </div>}
                

                {aIModalTips && JSON.stringify(aIModalTips) != '{}' &&<div className='endTips' style={aIModalTips.position === 'top' ? {top:100, bottom: 'initial'}:{}}>
                    {
                        aIModalTips.status === "success" ? (
                            <CheckCircleOutlined />
                        ) : aIModalTips.status === "loading" ? (
                            <Spin size={"small"} style={{marginRight: 10,marginTop: '-2px'}}></Spin>
                        ):(
                            <CloseCircleOutlined />
                        )
                    }
                    {aIModalTips.msg}
                </div>}
            </div>

        </div>
        

        {/* 提问框 */}
        <div className='questionInputBox' 
            style={answerDataList && answerDataList.length > 0 ? {}:{marginRight: 0}}
            // style={answerDataList && answerDataList.length > 0 ? {}:{
            //     width: '41rem',
            //     padding: '1rem',
            //     margin: '0 50%',
            //     transform: 'translateX(-50%)'}}
        >

            <dvi className="questionBox">
                <div className='endTopic' onClick={endTopic}>
                    <AntdImage
                        src={newTopic}
                        preview={false}
                    />新建话题
                </div>
                {/* storage.getItem("aiQAParams").saerchParams.knowledgeTypeId ||  */}
                <QASearchInput
                    pageType={"knowledgeQA"}
                    defaultSearchValue={recommendValue}
                    sendQuestion={assembleSendParameters}
                    isAnswering={isAnswering}
                    stopAnswer={stopAnswer}
                    questionParam={questionParam}
                    clientId={clientId}
                />
            </dvi>
            
        </div>

    </div>
}

export default KnowledgeQA;